import { Button, ClickAwayListener, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasActiveRoute, routeActive } from '@utils/routes';
import { useStyles } from './styles/MainBarHeader.styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useSelector } from 'react-redux';
import { checkPathHasPermission } from '@utils/permissions';

import type { RouteSegment } from '@/types/routes';
import type { RootState } from '@features/redux/store';

interface SegmentRouteProps {
    segment: RouteSegment;
}

export const SegmentRoute = ({ segment }: SegmentRouteProps) => {
    const classes = useStyles();
    const role = useSelector((state: RootState) => state.auth.Roles.role);

    const navigate = useNavigate();

    const [dropdownAnchor, setDropdownAnchor] = useState<HTMLElement | null>(null);

    return (
        <React.Fragment>
            <Button
                sx={{ textTransform: 'capitalize' }}
                color={'secondary'}
                onClick={(e) => {
                    setDropdownAnchor(dropdownAnchor ? null : e.currentTarget);
                }}
                startIcon={hasActiveRoute(segment.routes) ? segment.IconActive : segment.Icon}
                endIcon={<KeyboardArrowDownIcon />}>
                {segment.name}
            </Button>

            <Menu open={Boolean(dropdownAnchor)} anchorEl={dropdownAnchor}>
                <ClickAwayListener onClickAway={() => setDropdownAnchor(null)}>
                    <div>
                        {segment.routes.map(
                            (route) =>
                                checkPathHasPermission(role, route.link) && (
                                    <MenuItem
                                        key={route.link}
                                        onClick={() => {
                                            navigate(route.link);
                                            setDropdownAnchor(null);
                                        }}
                                        className={routeActive(route) ? classes.headerItemActive : classes.headerItem}>
                                        {routeActive(route) ? route.IconActive : route.Icon}

                                        <div style={{ marginLeft: 5 }}>{route.label}</div>
                                    </MenuItem>
                                )
                        )}
                    </div>
                </ClickAwayListener>
            </Menu>
        </React.Fragment>
    );
};
